import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

// 45859: keeps the PDP availability box in sync with the selected variant.
// On variant:update the Horizon variant picker only morphs ITSELF, but it fetches the
// full re-rendered page and ships that document with the event — so this element just
// picks its own re-rendered counterpart out of event.detail.data.html and morphs to it
// (same pattern as the native product-inventory.js). No extra network request.
class NikinAvailabilityBox extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  /** @param {CustomEvent} event */
  #update = (event) => {
    // Ignore updates from another product's picker (e.g. a quick-add card).
    const sourceProductId = event.target instanceof HTMLElement ? event.target.dataset.productId : undefined;
    if (sourceProductId && this.dataset.productId && sourceProductId !== this.dataset.productId) return;

    const html = event.detail?.data?.html;
    const source = html?.querySelector('nikin-availability-box');
    if (!source) return;

    morph(this, source, { childrenOnly: true });
  };
}

if (!customElements.get('nikin-availability-box')) {
  customElements.define('nikin-availability-box', NikinAvailabilityBox);
}
